import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IServiceConfig } from '../../configurations/store/configurations.types'
import { getServiceConfigSelector } from '../../configurations/selectors/serviceConfig.selector'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ICcHpiOptionsState } from '../../options/store/options.types'
import { setReasonForEncounter, setDrugsAndAlcohol } from '../store/ccHpi.actions'
import { getCcHpiOptionsSelector } from '../../options/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { CcHpiConstants } from '../store/ccHpi.constants'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { IPcr } from '../../pcr/store/pcr.types'

export function* setCCHPIDefaults() {
  try {
    const pcrID: string = yield select(getPcrIdSelector)
    const serviceId: string = yield select(getServiceIdSelector)
    if (pcrID) {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.ccHpiInjuryDetails) {
        return
      }
      const serviceConfig: IServiceConfig = yield select(getServiceConfigSelector)
      const { ENCOUNTER_DEFAULT, DRUGALC_DEFAULT } = serviceConfig
      const ccHpiOptionsState: ICcHpiOptionsState = yield select(getCcHpiOptionsSelector)
      const { reasonForEncounterOptions, drugsAndAlcoholOptions } = ccHpiOptionsState
      const defaultReasonForEncounter = reasonForEncounterOptions.find((option) => option.id === ENCOUNTER_DEFAULT)
      const defaultDrugsAndAlcoholIndicators = drugsAndAlcoholOptions.find((option) => option.id === DRUGALC_DEFAULT)
      yield put(setReasonForEncounter(defaultReasonForEncounter))
      yield put(setDrugsAndAlcohol(defaultDrugsAndAlcoholIndicators))
    }
  } catch (e) {
    yield put(throwPcrException(`setCCHPIDefaults() error: ${e}`))
  }
}

export function* setCCHPIDefaultsSaga() {
  yield takeLatest([CcHpiConstants.SET_CCHPI_DEFAULTS], performWithMutexHOG, setCCHPIDefaults)
}
